<div class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "MYORDERS.MYORDERS" | translate | uppercase }}</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="center p-24 pb-56" fusePerfectScrollbar>
        <div class="content">
            <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="h1 pr-16">Órdenes de Trabajo</div>
                    <button
                        mat-icon-button
                        color="accent"
                        (click)="mostrarFiltros = !mostrarFiltros"
                    >
                        <mat-icon color="secondary">filter_list</mat-icon>
                    </button>
                </div>

                <app-filtro-oott
                    *ngIf="clientes && estados && situaciones"
                    [clientes]="clientes"
                    [situaciones]="situaciones"
                    [estados]="estados"
                    [hidden]="!mostrarFiltros"
                    [estadoPago]="estadoPago"
                    [setearFiltros]="setearFiltros"
                    (filtrarOOTT)="filtrar($event)"
                ></app-filtro-oott>
                <app-listado-oott
                    *ngIf="ootts"
                    [ootts]="ootts"
                    [total]="total"
                    (editarNroTicketEvent)="editarNroTicket($event)"
                    (buscarMas)="buscarOrdenesDeTrabajo($event)"
                    (asignarOOCC)="asignarOOCC($event)"
                ></app-listado-oott>
            </div>
        </div>
    </div>

    <!-- / CONTENT -->
</div>
